import pkg from './eventBus';
export default pkg;


/** WEBPACK FOOTER **
 ** ./lib/event-bus-rx/index.js
 **/